import {TermDescriptor} from '@planday-corp/globalization';

export const LABELS: {
  [key: string]: TermDescriptor;
} = {
  signupToPlanday: {
    term: 'SignUp.ExternalSignup_Xero_Header',
    fallback: 'Start your free Planday trial using your Xero account details',
  },
  theFormIsPrefilled: {
    term: 'SignUp.ExternalSignup_Xero_Description',
    fallback:
      'The form is pre-filled with details from your Xero account. Please enter the additional information required to sign up for Planday.',
  },
  firstName: {
    term: 'SignUp.FirstName',
    fallback: 'First name',
  },
  lastName: {
    term: 'SignUp.LastName',
    fallback: 'Last name',
  },
  password: {term: 'SignUp.Password', fallback: 'Password'},
  userNameEmail: {
    term: 'SignUp.Email',
    fallback: 'Username (Email)',
  },
  phoneCountryCodePrefix: {
    term: 'SignUp.CountryCode',
    fallback: 'Country code',
  },
  country: {term: 'SignUp.Country', fallback: 'Country'},
  phoneNumber: {term: 'SignUp.Phone', fallback: 'Phone'},
  companyName: {term: 'SignUp.Company', fallback: 'Company Name'},
  industry: {
    term: 'SignUp.Industry',
    fallback: 'Industry',
  },
  employees: {term: 'SignUp.Employees', fallback: 'Employees'},
  signup: {term: 'SignUp.SignUpCTA_button', fallback: 'Sign up'},
  connectYourXeroOrganisation: {
    term: 'SignUp.AuthorizationPage_ModalTitle',
    fallback: 'Connect your Xero organisation to Planday',
  },
  xeroOrganisations: {
    term: 'SignUp.AuthorizationPage_XeroOrganisations',
    fallback: 'Xero organisations',
  },
  continue: {
    term: 'CommonTerms.Continue',
    fallback: 'Continue',
  },
  loginModalTitle: {
    term: 'SignUp.AuthorizationPage_LoginModal_Title',
    fallback: 'Log in to Planday',
  },
  loginBtn: {
    term: 'CommonTerms.Login',
    fallback: 'Log in',
  },
  signupModalTitle: {
    term: 'SignUp.AuthorizationPage_SignupModal_Title',
    fallback: 'Sign up to Planday',
  },
  signupBtn: {
    term: 'CommonTerms.XeroSignup',
    fallback: 'Sign up',
  },
  linkChooseAnotherOrg: {
    term: 'SignUp.AuthorizationPage_ChooseDifferentOrganisation',
    fallback: 'Connect a different Xero organisation',
  },
  errorScreenTitle: {
    term: 'SignUp.ErrorScreen_XeroAccessDenied_Title',
    fallback: 'Unable to connect you to Planday',
  },
  errorScreenBody: {
    term: 'SignUp.ErrorScreen_XeroAccessDenied_Description',
    fallback:
      'We were unable to connect Planday with your Xero account. To reconnect, go back and try again.',
  },
  errorScreenBtn: {
    term: 'SignUp.ErrorScreen_XeroAccessDenied_Btn',
    fallback: 'Go back and try again',
  },
  termsAndConditionsCheckboxText: {
    term: 'SignUp.TermsAndConditions_CheckboxText',
    fallback:
      'I have read and agree to the Trial Terms, Privacy Policy, Terms & Conditions, End User License Agreement and Data Processing Agreement.',
  },
  seeAllDocuments: {
    term: 'SignUp.TermsAndConditions_SeeAllDocuments',
    fallback: 'See all documents',
  },
  here: {
    term: 'SignUp.TermsAndConditions_Here',
    fallback: 'here',
  },
  termsAndConditionsLink: {
    term: 'SignUp.TermsAndConditions_Link',
    fallback: 'https://www.planday.com/legal',
  },
  termsAndConditionsAriaTitle: {
    term: 'SignUp.TermsAndConditions_Link_AriaTitle',
    fallback: 'See all documents here',
  },
  onboardingExampleStepsTitle: {
    term: 'Onboarding.Setup_XeroToPlanday_ExampleSteps_title',
    fallback: 'Get ready to schedule your employees smarter:',
  },
  onboardingExampleStepsList: {
    term: 'Onboarding.Setup_XeroToPlanday_ExampleSteps_list',
    fallback: `Import your employees' data from Xero to Planday;Enable the relevant Awards to cover your employees;Prepare for payroll with Planday and Xero connected`,
  },
  onboardingStatusInProgress: {
    term: 'Onboarding.Setup_XeroToPlanday_ProgressStatus_title',
    fallback: 'Building your Planday system...',
  },
  onboardingStatusFinished: {
    term: 'Onboarding.Setup_XeroToPlanday_FinishedStatus_title',
    fallback: 'You can now set Planday up!',
  },
  onboardingAutoRedirectCountdown: {
    term: 'Onboarding.Setup_XeroToPlanday_RedirectCountdown',
    fallback: 'You will be redirected to your Planday system in {0} seconds.',
  },
  timeZone: {
    term: 'CommonTerms.TimeZone',
    fallback: 'Time zone',
  },
  close: {
    term: 'CommonTerms.Close',
    fallback: 'Close',
  },
};
